import { render, staticRenderFns } from "./GroupFault.vue?vue&type=template&id=2af3eeb6&"
import script from "./GroupFault.vue?vue&type=script&lang=ts&"
export * from "./GroupFault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports